import { intlFormat, format, parseISO } from 'date-fns'

export function formatDate (input: string): string | null {
  try {
    return intlFormat(parseISO(input), { day: '2-digit', month: '2-digit', year: 'numeric' })
  } catch (e) {
    return null
  }
}

export function formatTime (input: string | Date): string {
  return format(new Date(input), 'MM/dd/yyyy HH:mm')
}
